import { render, staticRenderFns } from "./CMStatsComponent.vue?vue&type=template&id=648f5e86&scoped=true"
import script from "./CMStatsComponent.vue?vue&type=script&lang=ts"
export * from "./CMStatsComponent.vue?vue&type=script&lang=ts"
import style0 from "./CMStatsComponent.vue?vue&type=style&index=0&id=648f5e86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f5e86",
  null
  
)

export default component.exports